module.exports = __webpack_public_path__ + "media/images/icons/shop-e4ee5b096607b07a71463a78868d5ef8.svg";